<template>
  <!-- ======= Hero Section ======= -->
  <SliderCarouselVue />
  <!-- End Hero -->

  <!-- ======= Course Section ======= -->
  <!-- <CourseComponent /> -->
  <!-- End Course Section -->

  <!-- ======= Featured Services Section ======= -->
  <section id="featured-services" class="featured-services">
    <div class="container" data-aos="fade-up">
      <div class="row">
        <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="100">
            <div class="icon text-center">
              <i class="fas fa-truck"></i>
            </div>
            <h4 class="title text-center"><a href="">ساخت میکسر بتن</a></h4>
            <p class="description">6 الی 14 مترمکعبی رایش آلمان</p>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="200">
            <div class="icon text-center">
              <i class="fas fa-cog"></i>
            </div>
            <h4 class="title text-center"><a href="">فروش و تعمیرات</a></h4>
            <p class="description">مکانیکی ، هیدرولیکی و آهنگری</p>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="300">
            <div class="icon text-center">
              <i class="fas fa-industry"></i>
            </div>
            <h4 class="title text-center"><a href="">استاندارد جهانی</a></h4>
            <p class="description">عالی ترین کیفیت مخزن</p>
          </div>
        </div>

        <div class="col-md-6 col-lg-3 d-flex align-items-stretch mb-5 mb-lg-0">
          <div class="icon-box" data-aos="fade-up" data-aos-delay="400">
            <div class="icon text-center">
              <i class="fas fa-headset"></i>
            </div>
            <h4 class="title text-center"><a href="">پشتیبانی محصولات</a></h4>
            <p class="description">خدمات پس از فروش</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Featured Services Section -->

  <!-- ======= Cta Section ======= -->
  <section id="cta" class="cta">
    <div class="container" data-aos="zoom-in">
      <div class="text-center">
        <h3>سبلان میکسر</h3>
        <p>
         تراک میکسر‌ها به منظور انتقال و اختلاط بتن‌ها ساخته شده اند، که در این دو حالت بعضی اوقات ابتدا مخلوط شده وسپس بارگیری انجام می‌شود، اما در برخی دیگر مخلوط و حمل به طور همزمان صورت‌ می‌گیرد. این وسیله با قرارگیری تجهیزاتش بر روی شاسی یا نیمه تریلر ساخته‌ می‌شود،و در کل وزن آن معمولا بین 9 تا 14 تن است که باعث‌ می‌شود بتواند حدود 18 تن را حمل کند.
        </p>
      </div>
    </div>
  </section>
  <!-- End Cta Section -->
  <!-- ======= About Us Section ======= -->
  <AboutComponentVue />
  <!-- End About Us Section -->
  <!-- ======= Counts Section ======= -->

  <section id="counts" class="counts">
    <div class="container" data-aos="fade-up">
      <div class="row no-gutters">
        <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
          <div class="count-box">
            <i class="fas fa-cog"></i>
            <span
              data-purecounter-start="0"
              data-purecounter-end="85"
              data-purecounter-duration="1"
              class="purecounter"
            ></span>

            <p><strong>سبلان میکسر</strong> این یک متن آزمایشی است</p>
            <a href="#">ادامه مطلب &raquo;</a>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
          <div class="count-box">
            <i class="fas fa-cog"></i>
            <span
              data-purecounter-start="0"
              data-purecounter-end="26"
              data-purecounter-duration="1"
              class="purecounter"
            ></span>
            <p><strong>سبلان میکسر</strong> این یک متن آزمایشی است</p>
            <a href="#">ادامه مطلب &raquo;</a>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
          <div class="count-box">
            <i class="fas fa-cog"></i>
            <span
              data-purecounter-start="0"
              data-purecounter-end="14"
              data-purecounter-duration="1"
              class="purecounter"
            ></span>
            <p><strong>سبلان میکسر</strong> این یک متن آزمایشی است</p>
            <a href="#">ادامه مطلب &raquo;</a>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch">
          <div class="count-box">
            <i class="fas fa-cog"></i>
            <span
              data-purecounter-start="0"
              data-purecounter-end="150"
              data-purecounter-duration="1"
              class="purecounter"
            ></span>
            <p><strong>سبلان میکسر</strong> این یک متن آزمایشی است</p>
            <a href="#">ادامه مطلب &raquo;</a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- End Counts Section -->
  <!-- ======= Features Section ======= -->
  <section id="features" class="features">
    <div class="container" data-aos="fade-up">
      <div class="row">
        <div class="col-lg-6 order-2 order-lg-1" data-aos="fade-left">
          <div class="icon-box mt-5 mt-lg-0">
            <i class="bx bx-receipt"></i>
            <h4>سبلان میکسر</h4>
            <p>
سازنده انواع میکسرهای حمل بتن آماده 6 الی 14 متر مکعبی در طرح رایش آلمان

            </p>
          </div>
          <div class="icon-box mt-5">
            <i class="bx bx-cube-alt"></i>
            <h4>تعمیرات</h4>
            <p>
تعویض پره کشی ،قیف ،شوت و بچه شوت ، هفتی ،رولیک های ck45
            </p>
          </div>
          <div class="icon-box mt-5">
            <i class="bx bx-images"></i>
            <h4>خدمات</h4>
            <p>
ارائه دهنده بهترین خدمات با ورق های آلیاژی مبارکه اصفهان با موتوهای اصلی آلمان
            </p>
          </div>
          <div class="icon-box mt-5">
            <i class="bx bx-shield"></i>
            <h4>لوله کشی آب</h4>
            <p>
            لوله کشی آب با شیرآلات گازی و لوله های مانیسمان گوشت دار 
            </p>
          </div>
        </div>
        <div
          class="image col-lg-6 order-1 order-lg-2"
          style="
            background-image: url('/assets/img/gallery/سبلان-میکسر-001.jpg');
          "
          data-aos="zoom-in"
        ></div>
      </div>
    </div>
  </section>
  <!-- End Features Section -->
  <!-- ======= Services Section ======= -->
  <section id="services" class="services services">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>خدمات</h2>
        <p>
       تولید انواع میکسرهای حمل بتن 6 الی 14 متر ، تعمیرات موتور میکسر ، تعویض پره کشی و مشاوره و ...
        </p>
      </div>

      <div class="row">
        <div
          class="col-lg-4 col-md-6 icon-box"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          <div class="icon"><i class="fas fa-truck"></i></div>
          <h4 class="title"><a href="">تولید میکسر بتن</a></h4>
          <p class="description">
          ساخت و تولید انواع میکسرهای بتن در اندازه های متفاوت
          </p>
        </div>
        <div
          class="col-lg-4 col-md-6 icon-box"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div class="icon"><i class="fas fa-wrench"></i></div>
          <h4 class="title"><a href="">تعمیرات میکسر</a></h4>
          <p class="description">
           تعمیر تمامی قسمت های مربوط به میکسر بتن
          </p>
        </div>
        <div
          class="col-lg-4 col-md-6 icon-box"
          data-aos="zoom-in"
          data-aos-delay="300"
        >
          <div class="icon"><i class="fas fa-users"></i></div>
          <h4 class="title"><a href="">مشاوره ماشین آلات</a></h4>
          <p class="description">
          مشاوره تمامی ماشین آلات صنتعتی مربوط به بتن
          </p>
        </div>
        <div
          class="col-lg-4 col-md-6 icon-box"
          data-aos="zoom-in"
          data-aos-delay="100"
        >
          <div class="icon"><i class="fas fa-cog"></i></div>
          <h4 class="title"><a href="">تامین قطعات</a></h4>
          <p class="description">
          تامین انواع موتورها و گیربکس و سایر قطعات
          </p>
        </div>
        <div
          class="col-lg-4 col-md-6 icon-box"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div class="icon"><i class="fas fa-wind"></i></div>
          <h4 class="title"><a href="">لوله کشی میکسر</a></h4>
          <p class="description">
           
           لوله کشی آب با شیرآلات گازی لوله های مانیسمان  

          </p>
        </div>
        <div
          class="col-lg-4 col-md-6 icon-box"
          data-aos="zoom-in"
          data-aos-delay="300"
        >
          <div class="icon"><i class="fas fa-headphones"></i></div>
          <h4 class="title"><a href="">خدمات پس از فروش</a></h4>
          <p class="description">
          تضمین کیفیت و پشتیبانی از محصولات
          </p>
        </div>
      </div>
    </div>
  </section>
  <!-- End Services Section -->
  <!-- ======= Appointment Section ======= -->
  <!-- <section id="appointment" class="appointment section-bg">
            <div class="container" data-aos="fade-up">

                <div class="section-title">
                    <h2>Make an Appointment</h2>
                    <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p>
                </div>

                <form action="forms/appointment.php" method="post" role="form" class="php-email-form" data-aos="fade-up" data-aos-delay="100">
                    <div class="row">
                        <div class="col-md-4 form-group">
                            <input type="text" name="name" class="form-control" id="name" placeholder="Your Name" required>
                        </div>
                        <div class="col-md-4 form-group mt-3 mt-md-0">
                            <input type="email" class="form-control" name="email" id="email" placeholder="Your Email" required>
                        </div>
                        <div class="col-md-4 form-group mt-3 mt-md-0">
                            <input type="tel" class="form-control" name="phone" id="phone" placeholder="Your Phone" required>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 form-group mt-3">
                            <input type="datetime" name="date" class="form-control datepicker" id="date" placeholder="Appointment Date" required>
                        </div>
                        <div class="col-md-4 form-group mt-3">
                            <select name="department" id="department" class="form-select">
                                <option value="">Select Department</option>
                                <option value="Department 1">Department 1</option>
                                <option value="Department 2">Department 2</option>
                                <option value="Department 3">Department 3</option>
                            </select>
                        </div>
                        <div class="col-md-4 form-group mt-3">
                            <select name="doctor" id="doctor" class="form-select">
                                <option value="">Select Doctor</option>
                                <option value="Doctor 1">Doctor 1</option>
                                <option value="Doctor 2">Doctor 2</option>
                                <option value="Doctor 3">Doctor 3</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group mt-3">
                        <textarea class="form-control" name="message" rows="5" placeholder="Message (Optional)"></textarea>
                    </div>
                    <div class="my-3">
                        <div class="loading">Loading</div>
                        <div class="error-message"></div>
                        <div class="sent-message">Your appointment request has been sent successfully. Thank you!</div>
                    </div>
                    <div class="text-center"><button type="submit">Make an Appointment</button></div>
                </form>

            </div>
        </section> -->
  <!-- End Appointment Section -->
  <!-- ======= Articles Section ======= -->
  <ArticleComponentVue />
  <!-- End Departments Section -->
  <!-- ======= Testimonials Section ======= -->
  <CommentsComponentVue />
  <!-- End Testimonials Section -->

  <!-- ======= Gallery Section ======= -->
  <GalleryComponentVue />
  <!-- End Gallery Section -->

  <!-- ======= Frequently Asked Questioins Section ======= -->
  <FaqComponentVue />
  <!-- End Frequently Asked Questioins Section -->
  <!-- ======= Contact Section ======= -->
  <ContactComponent />
  <!-- End Contact Section -->
</template>


<script>
import SliderCarouselVue from "../components/SliderCarousel.vue";
import ContactComponent from "../components/ContactComponent.vue";
import FaqComponentVue from "../components/FaqComponent.vue";
import GalleryComponentVue from "../components/GalleryComponent.vue";
import ArticleComponentVue from "../components/ArticleComponent.vue";
import AboutComponentVue from "../components/AboutComponent.vue";
import CommentsComponentVue from "../components/CommentsComponent.vue";
// import CourseComponent from "../components/CourseComponent.vue";

export default {
  components: {
    SliderCarouselVue,
    ContactComponent,
    FaqComponentVue,
    GalleryComponentVue,
    ArticleComponentVue,
    AboutComponentVue,
    CommentsComponentVue,
  },
};
</script>

<style scoped>
p {
    line-height: 35px;
    font-size: 15px;
}


@media only screen and (max-width: 600px) {
 .icon-box{
  margin: 0 auto;
}
 
}

</style>